<template>
  <div class="organizing">
    <Orgheader />
    <Orgnavbox :dataList="beforeDataList" :bannarList="beforeBannarList" :titleList="beforeTitleList" />
    <Orgnavbox :dataList="liveDataList" :bannarList="liveBannarList" :titleList="liveTitleList" />
    <Orgnavbox :dataList="afterDataList" :titleList="afterTitleList" :isShowItem="false"/>
    <Orgextension />
  </div>
</template>

<script>
import Orgheader from './Orgheader.vue'
import Orgnavbox from './Orgnavbox.vue'
import Orgextension from './Orgextension.vue'
let beforeBannarList = [
  { id: 1, url: require('../../../../assets/orgextension/before1.jpg') },
  { id: 2, url: require('../../../../assets/orgextension/before2.jpg') },
  { id: 3, url: require('../../../../assets/orgextension/before3.jpg') },
  { id: 4, url: require('../../../../assets/orgextension/before4.jpg') },
  { id: 5, url: require('../../../../assets/orgextension/before5.jpg') },
  { id: 6, url: require('../../../../assets/orgextension/before6.jpg') },
  { id: 7, url: require('../../../../assets/orgextension/before7.jpg') },
]
let liveBannarList = [
  { id: 1, url: require('../../../../assets/orgextension/middle1.jpg') },
  { id: 2, url: require('../../../../assets/orgextension/middle2.jpg') },
  { id: 3, url: require('../../../../assets/orgextension/middle3.jpg') },
  { id: 4, url: require('../../../../assets/orgextension/middle4.jpg') },
  { id: 5, url: require('../../../../assets/orgextension/middle5.jpg') },
  { id: 6, url: require('../../../../assets/orgextension/middle6.jpg') },
  { id: 7, url: require('../../../../assets/orgextension/middle7.jpg') },
]
export default {
  components: {
    Orgheader,
    Orgnavbox,
    Orgextension,
  },
  data () {
    return {
      beforeDataList: [
        {
          id: 1,
          name: '创建赛事官网',
          icon: require('../../../../assets/orgextension/before-icon0.png'),
        },
        {
          id: 2,
          name: '智能报名',
          icon: require('../../../../assets/orgextension/before-icon1.png'),
        },
        {
          id: 3,
          name: '生成参赛证',
          icon: require('../../../../assets/orgextension/before-icon2.png'),
        },
        {
          id: 4,
          name: '资格审查系统',
          icon: require('../../../../assets/orgextension/before-icon3.png'),
        },
        {
          id: 5,
          name: '称重系统',
          icon: require('../../../../assets/orgextension/before-icon4.png'),
        },
        {
          id: 6,
          name: '一键抽检编排',
          icon: require('../../../../assets/orgextension/before-icon5.png'),
        },
        {
          id: 7,
          name: '秩序册、对战表下载',
          icon: require('../../../../assets/orgextension/before-icon6.png'),
        },
      ],
      liveDataList: [
        {
          id: 1,
          name: '智能检录',
          icon: require('../../../../assets/orgextension/live-icon0.png'),
        },
        {
          id: 2,
          name: '成绩实时云端同步',
          icon: require('../../../../assets/orgextension/live-icon1.png'),
        },
        {
          id: 3,
          name: '技术统计分析',
          icon: require('../../../../assets/orgextension/live-icon2.png'),
        },
        {
          id: 4,
          name: '赛事录屏/直播',
          icon: require('../../../../assets/orgextension/live-icon3.png'),
        },
        {
          id: 5,
          name: '奖牌榜/人气榜',
          icon: require('../../../../assets/orgextension/live-icon4.png'),
        },
        {
          id: 6,
          name: '智能竞赛设备',
          icon: require('../../../../assets/orgextension/live-icon5.png'),
        },
        {
          id: 7,
          name: '智能体能监测设备',
          icon: require('../../../../assets/orgextension/live-icon6.png'),
        },
      ],
      afterDataList: [
        {
          id: 1,
          name: '成绩册下载',
          icon: require('../../../../assets/orgextension/after-icon0.png'),
        },
        {
          id: 2,
          name: '参赛视频下载',
          icon: require('../../../../assets/orgextension/after-icon1.png'),
        },
        {
          id: 3,
          name: '打印获奖证书',
          icon: require('../../../../assets/orgextension/after-icon2.png'),
        },
        {
          id: 4,
          name: '多维度参赛数据分析',
          icon: require('../../../../assets/orgextension/after-icon3.png'),
        },
      ],
      beforeBannarList,
      liveBannarList,
      beforeTitleList: {
        before: '赛事执行',
        after: '赛前',
        info:'为综合性运动会、各种项目的所有赛制，建立竞赛设备物联网，线上线下数据互联互通'
      },
      liveTitleList: {
        before: '赛事执行',
        after: '比赛现场',
        info:'为综合性运动会、各种项目的所有赛制，建立竞赛设备物联网，线上线下数据互联互通'
      },
      afterTitleList: {
        before: '赛事执行',
        after: '赛后',
        info:'为综合性运动会、各种项目的所有赛制，建立竞赛设备物联网，线上线下数据互联互通'
      },
    }
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/daoba-match/views/home/detail/components/Organizing.vue